import { render, staticRenderFns } from "./OpeningHourItem.vue?vue&type=template&id=73ca5260&scoped=true&"
import script from "./OpeningHourItem.vue?vue&type=script&lang=ts&"
export * from "./OpeningHourItem.vue?vue&type=script&lang=ts&"
import style0 from "./OpeningHourItem.vue?vue&type=style&index=0&id=73ca5260&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ca5260",
  null
  
)

export default component.exports